module.exports = __webpack_public_path__ + "static/media/lp_header.6467fa53.svg";